import { onlyDigits } from './documents';

/** Máscara de telefone brasileiro idêntica à do protótipo (`formatBrazilPhone`). */
export function formatPhoneBR(value: string | null | undefined): string {
  const d = onlyDigits(value).slice(0, 11);
  if (!d) return '';
  if (d.length <= 2) return `(${d}`;
  const area = d.slice(0, 2);
  const local = d.slice(2);
  const prefix = d.length > 10 ? 5 : 4;
  if (local.length <= prefix) return `(${area}) ${local}`;
  return `(${area}) ${local.slice(0, prefix)}-${local.slice(prefix)}`;
}

export const isValidPhoneBR = (value: string) => {
  const d = onlyDigits(value);
  return d.length === 10 || d.length === 11;
};
